import { makeStyles } from '@material-ui/core';

export default makeStyles((theme) => ({
  accessDeniedImg: {
    height: 250,
    paddingTop: 0,
    paddingBottom: 10,
  },
  notFoundContainerBox: {
    // paddingRight: 125,
    height: 'calc(100vh - 120px)',
    display: 'flex',
  },
  boxContent: {
    width: '100%',
    alignSelf: 'center',
    marginTop: -130,
  },
  accessDeniedTxt: {
    fontSize: 20,
    color: theme.palette.grey[500],
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    lineHeight: '30px',
    maxWidth: 650,
    margin: 'auto',
    marginBottom: 20,
  },
}));
